import UpdateTextContentRequestModelBase from '../_generated/modelBases/update-text-content-request-model-base';

export default class UpdateTextContentRequestModel extends UpdateTextContentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
